const WS_PROTOCOL = window.location.protocol === 'https:' ? 'wss' : 'ws'

function isPagesPreviewHost(hostname) {
  const host = String(hostname || '').toLowerCase()
  return Boolean(host) && host.endsWith('.pages.dev')
}

function normalizeWsBaseUrl(input, { defaultPath } = { defaultPath: '/xiaozhi/v1/' }) {
  const raw = String(input || '').trim()
  if (!raw) return ''

  const ensurePath = (url) => {
    try {
      const parsed = new URL(url)
      if (!parsed.pathname || parsed.pathname === '/') parsed.pathname = defaultPath
      if (!parsed.pathname.endsWith('/')) parsed.pathname += '/'
      parsed.search = ''
      parsed.hash = ''
      return parsed.toString()
    } catch {
      return ''
    }
  }

  if (/^https?:\/\//i.test(raw)) {
    return ensurePath(raw.replace(/^http:/i, 'ws:').replace(/^https:/i, 'wss:'))
  }
  if (/^wss?:\/\//i.test(raw)) return ensurePath(raw)
  if (raw.startsWith('//')) return ensurePath(`${WS_PROTOCOL}:${raw}`)
  return ensurePath(`${WS_PROTOCOL}://${raw}`)
}

function normalizeWsPath(input) {
  const raw = String(input || '').trim()
  if (!raw) return ''
  const withPrefix = raw.startsWith('/') ? raw : `/${raw}`
  return withPrefix.endsWith('/') ? withPrefix : `${withPrefix}/`
}

export function buildWsUrlCandidates(targetDeviceId) {
  const deviceId = String(targetDeviceId || '').trim() || 'public-test'
  const params = new URLSearchParams({ 'device-id': deviceId, 'client-id': 'web-chat' })
  const query = `?${params.toString()}`
  const envWs = String(import.meta.env.VITE_WS_URL || '').trim()
  const apiOrigin = String(import.meta.env.VITE_API_ORIGIN || '').trim()
  const customPath = normalizeWsPath(import.meta.env.VITE_WS_PATH)
  const wsPaths = [customPath, '/chamii/v1/', '/xiaozhi/v1/'].filter(Boolean)

  const hostedDevBases = (() => {
    try {
      if (!isPagesPreviewHost(window.location.hostname)) return []
      return wsPaths.map((path) => `wss://admin-dev.chamii.com${path}`)
    } catch {
      return []
    }
  })()

  const sameOriginBases = wsPaths.map((path) => `${WS_PROTOCOL}://${window.location.host}${path}`)
  const legacyPortBases = window.location.protocol === 'http:'
    ? wsPaths.map((path) => `ws://${window.location.hostname}:30001${path}`)
    : []
  const envWsBases = envWs ? wsPaths.map((path) => normalizeWsBaseUrl(envWs, { defaultPath: path })) : []
  const apiWsBases = /^https?:\/\//i.test(apiOrigin)
    ? wsPaths.map((path) => normalizeWsBaseUrl(apiOrigin, { defaultPath: path }))
    : []

  const seen = new Set()
  return [...envWsBases, ...apiWsBases, ...hostedDevBases, ...sameOriginBases, ...legacyPortBases]
    .filter(Boolean)
    .map((base) => `${base}${query}`)
    .filter((url) => (seen.has(url) ? false : (seen.add(url), true)))
}

export function formatCloudMessageTime(timestamp) {
  const raw = String(timestamp || '').trim()
  if (!raw) return new Date().toLocaleTimeString()
  const parsed = new Date(raw)
  return Number.isNaN(parsed.getTime()) ? raw : parsed.toLocaleTimeString()
}
